import main from "./main.js";
import { mainb } from "./mainB.js";
import React from "react";
import ReactDOM from "react-dom/client";

class Engine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // preserve existing side-effect behavior on mount
    // equivalent to previous constructor calling g_starter_A
  }

  loadpost_finisher() {
    // Render a transient element at the end of body as before
    var mains = document.createElement("DIV");
    mains.style.animation = "fadein 0.5s ease-in";
    mains.style.height = "150px";
    document.body.append(mains);

    var test = React.createElement(
      "div",
      { className: "loadpost_finisher" },
      null
    );

    ReactDOM.createRoot(mains).render(test);
  }

  render() {
    const MainB = mainb;
    return (
      <div id="main" className="md:w-full">
        <div
          id="app_1"
          className="bg-white/10 font-sans  w-[90%] mx-auto md:w-[100%] my-[30px] mt-0 border-bottom-2 text-white border-gray-300 rounded-[20px]"
        >
          <MainB />
        </div>
      </div>
    );
  }
}

export default Engine;
